export default __webpack_public_path__ + "static/media/data_new.657370a4.csv";